import { getAppInsights } from "../TelemetryService";
import { getUserData, getCurrentGroupName, getSession } from "../services/LocalStorageService";

export default async function trackEvents(name:string, data:any, params:any) {
  const userData = getUserData();
  const userSession = getSession();
  const AccessLevel = userSession && userSession.userRoles && userSession.userRoles.length ? userSession.userRoles : "";
  const CompanyName = await getCurrentGroupName(params);
  const CompanyId = userData && userData.userGroupId !== null ? userData.userGroupId : "";
  const UserId = userData && userData.id !== null ? userData.id : "";

  getAppInsights()?.appInsights?.trackEvent({
    name,
    properties: {
      ...data,
      AccessLevel,
      CompanyName,
      CompanyId,
      UserId,
    },
  });
}
